import {gql} from "apollo-boost";

export const DocumentTypesQuery = gql`
    query DocumentTypes{
        documentTypes{
            id
            description
        }
    }

`;